import React from 'react';
import styles from './loader.module.css';
import clsx from 'clsx';
import { Tloader } from '../../types';

interface Props {
    tpl?: Tloader
}
const Loader = ({ tpl = 'big' }: Props) => {

    const loaderClass = () =>
        clsx(
            styles['container-loader'],
            {
                [styles['container-loader-big']]: tpl === 'big',
                [styles['container-loader-small']]: tpl === 'small',
            }
        );

    return (
        <div className={loaderClass()}>
            <div className={styles.loader}></div>
            {tpl === 'big' && (<div>Подождите...</div>)}
        </div>
    );
};

export default Loader;